import React from "react";
import { useRouter } from "next/router";

import ActionsModal from "@/components/Modals/ActionsModal";
import AlertIcon from "@/icons/alert.svg";
import Typography from "@/components/Typography";
import { routePath } from "@/helpers/routePath";
import { BaseModalInterface } from "@/components/Modals/Modal.interface";

export const RedoOnboardingModal: React.FC<BaseModalInterface> = ({
  onClose,
  isOpen,
}) => {
  const router = useRouter();

  const confirmAction = () => {
    router.push({
      pathname: routePath.ONBOARDING_PERSONALIZE.href,
      query: { from: "settings" },
    });
  };

  return (
    <ActionsModal
      isOpen={isOpen}
      onClose={onClose}
      cancelActionLabel="Anuluj"
      confirmActionLabel="Przejdź"
      confirmActionHandler={confirmAction}
    >
      <AlertIcon />
      <Typography variant="h2" component="p">
        Czy na pewno chcesz jeszcze raz przejść przez onboarding? Usuniemy
        wszystkie aktualne ustawienia zainteresowań
      </Typography>
    </ActionsModal>
  );
};

export default RedoOnboardingModal;
